<template>
  <li
    :id="'scroll-content-' + option.key"
    class="dropdown-option align-items-center"
    :class="option.isDisabled && 'disabled'"
    @click="!option.isDisabled ? onClick() : null">
    <input
      type="radio"
      name="option"
      role="option"
      :disabled="option.isDisabled"
      :aria-labelledby="'label-' + option.key"/>
    <div :id="'label-' + option.key" :class="{'text-bold': isSelected}">
      {{ option.name }}
      <span class="radio">
        <span :class="isSelected ? 'isSelected' : ''"></span>
      </span>
    </div>
  </li>
</template>

<script>

export default {
  name: 'Option',
  props: {
    option: Object,
    isSelected: Boolean
  },
  data: () => ({}),
  computed: {},
  methods: {
    onClick () {
      if (!this.isSelected) {
        this.$emit('select', this.option)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-option {
  display: flex;
  padding: 8px !important;

  & div {
    display: flex;
    width: 100%;
    align-content: center;
    justify-content: space-between;

    & .radio {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      border: 1px solid #666666;

      & span {
        height: 12px;
        width: 12px;
        border-radius: 50%;

        &.isSelected {
          background-color: #b1281e;
        }
      }
    }
  }

  &.disabled {
    cursor: initial !important;

    & div {
      color: #cbcbcb !important;

      & .radio {
        border: 1px solid #cbcbcb;
      }
    }

    &:hover {
      background: none !important;
      font-weight: initial !important;
    }
  }
}
</style>
